module.exports = __webpack_public_path__ + "img/product-sm-6.99b65161.png";